/* eslint-disable */
import React from 'react';
import Styles from './index.less';
import i18n from '@i18next/i18n';
import markdownit from 'markdown-it';
import {EventType, SSEService} from '@src/slide/application/service/ai-ssistant/ai-generator/sse';
import axios from 'axios';
import {
    MARKDOWN_EXPERT_DESCRIPTION
} from '@framework/workbench/ui/ai-review/components/ai-review-drawer-content/prompt-prefix';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

interface IAiReviewDrawerContentProps {
    aiPrompt: string;
}

interface IAiReviewDrawerContentState {
    message: string;
    isLoading: boolean;
    prompt: string;
}

export class AiReviewDrawerContent extends React.Component<IAiReviewDrawerContentProps, IAiReviewDrawerContentState> {
    private md = markdownit({
        breaks: true,
        html: true,
    });

    private timeout: any;
    private abortAbility: (() => void) | undefined;
    private totalString = '';
    private lastOutput: string = '';
    private lastPageStartIndex = -1;

    public constructor(props: IAiReviewDrawerContentProps) {
        super(props);

        this.state = {
            message: '',
            isLoading: true,
            prompt: MARKDOWN_EXPERT_DESCRIPTION + ' ' + props.aiPrompt,
        };
    }

    public componentWillUnmount() {
        clearTimeout(this.timeout);
        if (this.abortAbility) {
            this.abortAbility();
        }
    }

    public async componentDidMount() {
        if (this.props.aiPrompt?.length === 0) {
            // 空内容直接输出
            this.showNoProblem(true);
            return;
        }

        // // 本地调优prompt代码
        // const data = await this.getJsonData();
        // const list = this.mockDelayMarkdown(data);
        // this.delayParse(list, 0, '');
        // return;

        // 调试后台接口
        this.totalString = '';
        const { abort } = SSEService.fullContentReview(this.props.aiPrompt, ({ type, data }) => {
            if (type === EventType.DONE) {
                this.handlePageEnd(true);
                const htmlResul = this.md.render(this.totalString);

                // 数据流返回结束
                this.setState({
                    message: htmlResul,
                    isLoading: false,
                });
                this.abortAbility = undefined;

                tdw({
                    opername: TDWOperationType.DOC_PPT_AI,
                    module: TDWModuleType.LAYOUT_CHECK,
                    action: TDWActionType.SUCCESS,
                    ver5: TDWModuleType.PC,
                });
                return;
            }

            if (type === EventType.CONTENT) {
                // 数据流返回内容，拼接后显示
                const t = data?.content?.content?.text;
                if (!t) return;

                this.totalString = this.totalString + t;
                this.showNewContent(t);
            }
        });

        this.abortAbility = abort;
    }

    public render() {
        return <div
                onWheel={(e) => {
                    e.stopPropagation();
                    e.nativeEvent.stopPropagation();
                }}
                className={Styles['ai-review-drawer-content-container']}>
            <div className={Styles['ai-review-talk-dialog-container']}>
                <div dangerouslySetInnerHTML={{
                    __html: this.state.message,
                }} className={Styles['ai-review-talk-dialog-text']}>
                </div>
                {
                    this.state.isLoading && <div className={Styles['ai-review-result-loading-container']}>
                        <div className={Styles['ai-review-result-loading-icon']}/>
                        <div className={Styles['ai-review-result-loading-text']}>
                            {
                                i18n.t('正在为你输出结果...')
                            }
                        </div>
                    </div>
                }
            </div>
        </div>;
    }

    /**
     * 显示新内容
     * @param t
     * @private
     */
    private showNewContent(t: string) {
        const content = t + this.lastOutput;
        const pagePrefix = '### ';
        const problemPrefix = '#### ';
        if (content.includes(pagePrefix) && !content.includes(problemPrefix)) {
            // 页面内容开始，标志着上一页内容结束
            this.handlePageEnd();
        }

        const htmlResul = this.md.render(this.totalString);
        this.setState({
            message: htmlResul,
        });
        this.lastOutput = t;
    }

    /**
     * 页面数据完成触发
     * @private
     */
    private handlePageEnd(allEnd: boolean = false) {
        const pagePrefix = '\n### ';
        let newPageIndex = this.totalString.lastIndexOf(pagePrefix);
        if (newPageIndex === -1) {
            // 从后面匹配不到说明就是第一次出现了，不需要换行符
            newPageIndex = this.totalString.indexOf('### ');
        }
        let lastPageIndex = this.totalString.substring(0, newPageIndex).lastIndexOf(pagePrefix);
        if (lastPageIndex === -1) {
            // 从后面匹配不到说明就是第一次出现了，不需要换行符
            this.totalString.substring(0, newPageIndex).indexOf('### ');
        }
        if (allEnd) {
            // 全部结束
            const lastPageContent = this.totalString.substring(newPageIndex);
            const handledPageContent = this.checkNewPageContent(lastPageContent);
            this.totalString = this.totalString.substring(0, newPageIndex) + handledPageContent;
            if (this.totalString.length === 0) {
                this.showNoProblem(true);
            }
        }

        if (this.lastPageStartIndex === -1) {
            // 第一次遇到，前面没有内容，不需要处理
            this.lastPageStartIndex = newPageIndex;
        } else {
            // 处理上一页内容
            const lastPageContent = this.totalString.substring(lastPageIndex, newPageIndex);
            const newContent = this.totalString.substring(newPageIndex);
            const handledPageContent = this.checkNewPageContent(lastPageContent);
            this.totalString = this.totalString.substring(0, lastPageIndex) + handledPageContent + newContent;
        }
    }

    private checkNewPageContent(pageString: string): string {
        const beforeProblems = pageString.split('#### ');
        let afterProblems: string[] = [];
        for (let i = 1; i < beforeProblems.length; i++) {
            // 第0个是页码表示，跳过
            const problem = beforeProblems[i];
            const suggestIndex = problem.indexOf('修改建议');
            if (suggestIndex !== -1) {
                const suggestString = problem.substring(suggestIndex + 4);
                if (this.containsNoProblemCase(suggestString)) continue;
                // 不包含badCase的正确内容，添加到数组中
                afterProblems.push('#### ' + problem);
            }
        }

        // 没有明显错误，不输出该页
        if (afterProblems.length === 0) return '';
        if (beforeProblems[0].length > 0) {
            afterProblems.unshift(beforeProblems[0]);
        }

        let afterHandlePageString = '';
        for (let i = 0; i < afterProblems.length; i++) {
            afterHandlePageString = afterHandlePageString + afterProblems[i];
        }

        return afterHandlePageString;
    }

    /**
     * 输出没有问题的结果
     * @param withEnd
     * @private
     */
    private showNoProblem(withEnd: boolean)  {
        this.totalString = '### 总结\n'
            + '经分析，您的PPT文档内容未发现严重问题，请继续保持。\n';
        const htmlResul = this.md.render(this.totalString);
        this.setState({
            message: htmlResul,
            isLoading: false,
        });
    }

    /**
     * 提示词处理不好的地方，在这里兜一下
     * @param suggestString
     * @private
     */
    private containsNoProblemCase(suggestString: string): boolean {
        const noProblemStrings = ['使用正确', '没有拼写错误', '无需修改'];
        for (let i = 0; i < noProblemStrings.length; i++) {
            if (suggestString.includes(noProblemStrings[i])) {
                return true;
            }
        }
        return false;
    }


    private getJsonData = async () => {
        const result = await axios.post('https://docs.qq.com/v1/ai/aiengine/chatcompletions', {
            platform: 1,
            model: 'hunyuan-turbo',
            messages: [
                {
                    role: 'user',
                    text: this.getAiReviewParam(),
                },
            ],
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return result.data.result?.choices?.[0]?.message?.text || '';
    };


    private mockDelayMarkdown = (mockResult: string) => {
        mockResult = mockResult.replaceAll('\\n', '\n');
        // .replaceAll('###', '### ')
        // .replaceAll('##', '## ');
        const list: string[] = [];
        for (let i = 0; i < mockResult.length; i = i + 10) {
            let str = '';
            for (let j = 0; j < 10; j++) {
                if (mockResult[j] && mockResult[i + j]) {
                    str += mockResult[i + j];
                }
            }

            list.push(str);
        }

        return list;
    };

    private getAiReviewParam = () => {
        return MARKDOWN_EXPERT_DESCRIPTION + ' ' + this.props.aiPrompt;
    };

    private delayParse = (list: string[], index: number, total: string) => {
        const str = list[index];
        if (str) {
            total = total + str;
            const htmlResul = this.md.render(total);
            this.setState({
                message: htmlResul,
            });

            this.timeout = setTimeout(() => {
                this.delayParse(list, index + 1, total);
            }, 200);
        } else {
            this.setState({
                isLoading: false,
            });

            tdw({
                opername: TDWOperationType.DOC_PPT_AI,
                module: TDWModuleType.LAYOUT_CHECK,
                action: TDWActionType.SUCCESS,
                ver5: TDWModuleType.PC,
            });
        }
    };
}
